import React, { useState } from 'react';
import Body from "./body";
import Nav from "./nav";
import { Routes, Route } from 'react-router-dom';
import UserOrderArchieve from '../components/UserPages/UserArchivedOrders';
import LogOff from '../components/UserPages/LogOff';
import UserData from '../components/UserPages/UserData';
import Settings from '../components/SettingsPages/Settings';
import RestaurantMenus from '../components/SettingsPages/RestaurantMenus';
import RequireRole from '../auth/RequireRole';
import Role from '../utils/enum/role';
import AddRestaurantMenu from '../components/SettingsPages/AddRestaurantMenu';
import EditExistingMenu from '../components/SettingsPages/EditExistingMenu';
import AddItemToMenu from '../components/SettingsPages/AddItemToMenu';
import Schedule from '../components/SettingsPages/Schedule';
import TotalOrders from '../components/SettingsPages/TotalOrders';
import EmployeeOrdersDetail from '../components/SettingsPages/EmployeeOrdersDetail';
import PeriodOrders from '../components/SettingsPages/PeriodOrders';
import EmployeeStatement from '../components/SettingsPages/EmployeeStatement';
import { useAppContext } from '../store/app_context';
import '../interceptors/fetchInterceptor.jsx';
const Layout = () => {

    const { totalMonthPrice, orderTimeSettings } = useAppContext();

    return (
            <div className="page">
                <Nav totalMonthPrice={totalMonthPrice} />
                <section className="banner">
                    <div className="container">
                        <div className="text">
                            <h1>طلب الأكل اللي نفسك فيه</h1>
                            <p>يتم الطلب من الساعة {orderTimeSettings?.startTime} وحتى الساعة {orderTimeSettings?.endTime}</p>

                        </div>
                    </div>
                </section>
                <Routes>

                    <Route path="/" element={<Body />} />
                    <Route path="/user/edit" element={<UserData />} />
                    <Route path="/admin" element={<RequireRole roles={[Role.Admin]}><Settings /></RequireRole>} />
                    <Route path="/admin/add-menu" element={<RequireRole roles={[Role.Admin]}><AddRestaurantMenu /></RequireRole>} />
                    <Route path="/admin/edit-menu" element={<RequireRole roles={[Role.Admin]}><EditExistingMenu /></RequireRole>} />
                    <Route path="/admin/add-item" element={<RequireRole roles={[Role.Admin]}><AddItemToMenu /></RequireRole>} />
                    <Route path="/admin/menus" element={<RequireRole roles={[Role.Admin]}><RestaurantMenus /></RequireRole>} />
                    <Route path="/admin/schedule" element={<RequireRole roles={[Role.Admin]}><Schedule /></RequireRole>} />
                    <Route path="/admin/total-orders" element={<RequireRole roles={[Role.Admin]}><TotalOrders /></RequireRole>} />
                  
                    <Route path="/admin/employee-orders" element={<RequireRole roles={[Role.Admin]}><EmployeeOrdersDetail /></RequireRole>} />
                    <Route path="/admin/period-orders" element={<RequireRole roles={[Role.Admin]}><PeriodOrders /></RequireRole>} />
                    <Route path="/admin/employee-statement" element={<RequireRole roles={[Role.Admin]}><EmployeeStatement /></RequireRole>} />
                    <Route path="/employee/orders.archives" element={<RequireRole roles={[Role.Admin,Role.Employee]}><UserOrderArchieve /></RequireRole>} />

                    <Route path="/Account/LogOff" element={<LogOff />} />
                </Routes>

            </div>
    );
};

export default Layout;
